import { useSelector } from 'react-redux';
import { useBotContext } from '../useBotContext';
import { useDeleteAHU } from '../../dataHooks/ahu';
import BotForm from '../BotForm';
import BotResetButton from '../BotResetButton';
import Button from '../atom/Button';
import { BOT_MESSAGES, IAccessDoorParams, IAHUParams, ICoilParams, IErWheelParams } from '../../models';
import type { IState } from '../../../../models';
import { useFormChangeCleanup } from '../../hooks/useFormChangeCleanup';
import { useAhuDesign } from '../../hooks/useAhuDesign';
import { useBotValidation } from '../../hooks/useBotValidation';
import './BotContentInner.scss';

const BotContentInner = () => {
  const { value: botData, setValue } = useBotContext();
  const ahuParams = useSelector((s: IState) => s.ahu.ahu_params) as IAHUParams;
  const rotaryParams = useSelector(
    (s: IState) => s.erWheel.er_wheel_params,
  ) as IErWheelParams;
  const coil_params = useSelector(
    (s: IState) => s.coil.coil_params,
  ) as ICoilParams;
  const door_params = useSelector(
    (s: IState) => s.accessDoor.params,
  ) as IAccessDoorParams;
  const conn_hands = useSelector((s: IState) => s.coil.conn_hands);
  const { deleteAHU } = useDeleteAHU();

  const isFormValid = useBotValidation(botData);

  const {
    isDesigning,
    progress,
    error,
    success,
    startDesign,
    cancelDesign,
    resetUI,
  } = useAhuDesign({
    botData,
    ahuParams,
    rotaryParams,
    coilParams: coil_params,
    accessDoorParams: door_params,
    connHands: conn_hands,
    deleteAHU,
    setValue,
  });

  useFormChangeCleanup(botData, setValue, resetUI);

  const handleClick = () => {
    if (!isFormValid || !ahuParams) return;
    isDesigning ? cancelDesign() : startDesign();
  };

  return (
    <div className="w-100 bot-info__forms position-relative">
      <div className="bot-reset-button-container">
        <BotResetButton />
      </div>

      {isDesigning && (
        <div className="in-progress-warning active">
          <p>{BOT_MESSAGES.DESIGN_IN_PROGRESS}</p>
          <p>{BOT_MESSAGES.DESIGN_WAIT}</p>
          <div>
            <div className="active preloader dotted-preloader larger"></div>
            <div className="completed_percent">{progress}%</div>
          </div>
        </div>
      )}
      <BotForm />
      <div id="bot-select-reset-buttons">
        {error && (
          <div className="error-message-container">
            <p className="error-message-text">{error}</p>
          </div>
        )}
        {success && (
          <div className="success-message-container">
            <p className="success-message-text">{success}</p>
          </div>
        )}

        <Button
          text={isDesigning ? 'CANCEL' : 'SELECT'}
          disabled={!isFormValid || !ahuParams}
          onClick={handleClick}
          className={`bot-select-button ${isDesigning ? 'bot-cancel-brn' : ''}`}
        />
      </div>
    </div>
  );
};

export default BotContentInner;
